import { useTranslation } from "react-i18next";
import ExpandableRow from "./ExpandableRow";

export const ServiceRequest = ({ data, setOpenChatWindow }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="ui-card-bar relative mt-4">
        <div className="px-3 py-2 lg:p-4">
          <div className="grid grid-cols-1 md:grid-cols-7 gap-2 xl:gap-2">
            <div className="text-xs font-bold  text-theme-text-secondary md:col-span-3">
              {t("CustomerServiceRequest-service-type")}
            </div>
            <div className="text-xs font-bold  text-theme-text-secondary md:col-span-1">
              {t("CustomerServiceRequest-product-line")}
            </div>
            <div className="text-xs font-bold  text-theme-text-secondary md:col-span-1">
              {t("CustomerServiceRequest-policy")}
            </div>
            <div className="text-xs font-bold  text-theme-text-secondary md:col-span-1">
              {t("CustomerServiceRequest-service-id")}
            </div>
            <div className="text-xs font-bold  text-theme-text-secondary md:col-span-1">
              {t("CustomerServiceRequest-received-date")}
            </div>
          </div>
        </div>
      </div>
      {data.map((item) => {
        return (
          <ExpandableRow
            key={item.taskID}
            data={item}
            setOpenChatWindow={setOpenChatWindow}
          />
        );
      })}
      <p className="flex justify-end mt-5">
        {t("CustomerServices-serviceRequest-footer")}
      </p>
    </>
  );
};
